export const UPDATE_FILTER = "dataComponents.dateFilter.updateFilter";
export const CLEAR_FILTER = "dataComponents.dateFilter.clearFilter";
export const UPDATE_DATE_RANGE = "dataComponents.dateFilter.updateDateRange";
